import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Typography,
  message,
  Icon,
} from 'antd';

import { Spinner } from '../../UI';

import styles from './ChangePassword.module.css';

const { Title } = Typography;
const FormItem = Form.Item;

message.config({
  top: 12,
  duration: 3
});

class ChangePassword extends Component {
  state = {
    confirmDirty: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }

      const payload = {
        oldPswd: values['Old Password'],
        newPswd: values['Password'],
      };

      this.props.changePassword(payload, () => {
        if (!this.props.err.message) {
          this.props.form.resetFields();
          this.success('Password has been updated')
        } else {
          this.error(this.props.err.message);
        }
      });
    })
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('Password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  success = (msg) => {
    message.success(msg);
  };

  error = (msg) => {
    message.error(msg);
  };

  render() {
    const {
      loading,
      form: { getFieldDecorator },
    } = this.props;

    let content = <Spinner size="small" />;
    if (!loading) {
      const formControl = (name, settings, control) => (
        getFieldDecorator(name, {
          ...settings,
        })(control)
      );

      content = (
        <Form className={styles['user-form']}>
          <Row
            type="flex"
            gutter={15}
          >
            <Col
              lg={8}
              sm={12}
              xs={24}
            >
              <FormItem
                label="Old Password"
                className="form-item-wrapper"
              >
                {formControl(
                  'Old Password',
                  {
                    rules: [{ required: true, type: 'string' }],
                    initialValue: []
                  },
                  <Input
                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    size="large"
                    type="password"
                  />
                )}
              </FormItem>
            </Col>

            <Col
              lg={8}
              sm={12}
              xs={24}
            >
              <FormItem
                label="Password"
                className="form-item-wrapper"
                hasFeedback
              >
                {formControl(
                  'Password',
                  {
                    rules: [
                      { required: true, min: 8 },
                      { validator: this.validateToNextPassword },
                    ],

                  },
                  <Input
                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    size="large"
                    type="password"
                  />
                )}
              </FormItem>
            </Col>

            <Col
              lg={8}
              sm={12}
              xs={24}
            >
              <FormItem
                label="Confirm Password"
                className="form-item-wrapper"
                hasFeedback
              >
                {formControl(
                  'Confirm Password',
                  {
                    rules: [
                      { required: true, min: 8 },
                      { validator: this.compareToFirstPassword },
                    ],
                  },
                  <Input
                    prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    size="large"
                    type="password"
                  />
                )}
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" style={{ paddingTop: '10px' }}>
            <Col lg={12}>
              <Button
                className={styles.button}
                ghost
                type="primary"
                size="large"
                onClick={this.handleSubmit}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      );
    }

    return (
      <div>
        <Title level={4}>Change Password</Title>
        {content}
      </div>
    );
  }
}

ChangePassword.propTypes = {
  changePassword: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  err: PropTypes.object.isRequired
};

export default Form.create({})(ChangePassword);
